function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import defaultAlgorithm from "./default";
import darkAlgorithm from "./dark";
export { defaultAlgorithm, darkAlgorithm };
var v4Token = {
  token: {
    borderRadius: 2,
    colorPrimary: '#1890ff',
    wireframe: true
  }
};
export var defaultTheme = _objectSpread(_objectSpread({}, v4Token), {}, {
  algorithm: defaultAlgorithm,
  components: {
    Menu: {
      radiusItem: 0,
      radiusSubMenuItem: 0,
      colorItemTextHover: '#1890ff',
      colorItemTextSelected: '#1890ff',
      colorItemBgSelected: '#e6f7ff',
      colorActiveBarWidth: 3,
      itemMarginInline: 0,
      colorItemBgHover: 'transparent'
    }
  }
});
export var darkTheme = _objectSpread(_objectSpread({}, v4Token), {}, {
  algorithm: darkAlgorithm,
  components: {
    Menu: {
      radiusItem: 0,
      radiusSubMenuItem: 0,
      colorItemTextHover: '#1890ff',
      colorItemTextSelected: '#1890ff',
      colorItemBgSelected: '#111b26',
      colorActiveBarWidth: 3,
      itemMarginInline: 0,
      colorItemBgHover: 'transparent'
    }
  }
});